import * as React from "react";
import * as ReactRedux from "react-redux";

import RaisedButton from "material-ui/RaisedButton";
import CircularProgress from "material-ui/CircularProgress";
const SplitPane = require("react-split-pane");
import Editor from "./Editor";

import { AppIdInfo, selectors as userSelectors } from "../reducers/current_user";
import {
	AuthedUser,
	selectors as labSelectors,
	actions as labActions,
	LabExampleJs,
	LabExampleJSDataOutputEntry,
} from "../reducers/lab";

interface CodeProps {
	value: string;
	onChangeValue(value: string): void;
}

const Code = (props: CodeProps) => (
	<Editor
		value={props.value}
		onChangeValue={props.onChangeValue}
		isReadOnly={false}
		style={{ flex: 1, marginTop: "0.5rem", height: "" }}
		language="javascript"
	/>
);

function convertJsValueToString(value: any): string {
	if (typeof value === "undefined") {
		return "undefined";
	}

	if (value === null) {
		return "null";
	}

	if (typeof value === "object") {
		return JSON.stringify(value, null, 2);
	}

	return value.toString();
}

interface OutputProps {
	output: LabExampleJSDataOutputEntry[];
}

const OUTPUT_COLORS = {
	default: "white",
	info: "cyan",
	error: "red",
	warning: "yellow",
};

const Output = (props: OutputProps) => (
	<div
		style={{
			flex: 1,
			marginTop: "0.5rem",
			marginBottom: 0,
			padding: "1rem",
			color: "white",
			position: "absolute",
			top: 0,
			left: 0,
			bottom: 0,
			right: 0,
			overflowY: "scroll",
			whiteSpace: "pre-wrap",
			wordBreak: "break-word",
			fontFamily: "monospace",
		}}
	>
		{props.output.map((o, i) => {
			console.log(props.output);
			const color = OUTPUT_COLORS[o.logLevel];

			if (i === 0) {
				return (
					<span key={i} style={{ color }}>
						{convertJsValueToString(o.value)}
					</span>
				);
			}

			const prev = convertJsValueToString(props.output[i - 1].value);
			const curr = convertJsValueToString(o.value);

			const value: string =
				(curr === "\n" || prev.charAt(prev.length - 1) === "\n" || prev.length === 0 ? "" : " ") +
				curr;

			return (
				<span key={i} style={{ color }}>
					{value}
				</span>
			);
		})}
	</div>
);

interface LabContentJsProps {
	apps: AppIdInfo[];
	authedUser: AuthedUser;
	isFullscreen: boolean;
	example: LabExampleJs;
	splitSize: number | string;

	changeSplitSize(size: number);
	changeExampleData(exampleData: any);
	runJsExample(appId: string);
}

class LabContentJs extends React.Component<LabContentJsProps> {
	private originalLog: any;

	changeCode(newCode: string) {
		const { example } = this.props;

		this.props.changeExampleData({
			...example.data,
			code: newCode,
		});
	}

	render() {
		const { isFullscreen, example, runJsExample, apps, splitSize, changeSplitSize } = this.props;

		return (
			<div
				style={{
					flex: 1,
					display: "flex",
					flexDirection: "column",
					position: "relative",
				}}
			>
				<SplitPane
					split={isFullscreen ? "vertical" : "horizontal"}
					size={splitSize}
					onDragFinished={changeSplitSize}
					paneStyle={{
						display: "flex",
						flexDirection: "column",
					}}
				>
					<div
						style={{
							display: "flex",
							flexDirection: "column",
							flex: 1,
						}}
					>
						<Code value={example.data.code} onChangeValue={this.changeCode.bind(this)} />

						<RaisedButton
							label={"Run"}
							primary
							disabled={example.data.status === "pending"}
							style={{
								margin: "1rem",
							}}
							onClick={runJsExample.bind(this, apps[0].value)}
						/>
					</div>

					<div
						style={{
							display: "flex",
							flex: 1,
							alignItems: "center",
							justifyContent: "center",
							position: "relative",
						}}
					>
						{example.data.status === "" && (
							<p style={{ color: "white", margin: 0 }}>Press "Run" to see a result.</p>
						)}
						{example.data.status === "pending" && (
							<CircularProgress color="#66D9EF" size={60} thickness={3} />
						)}
						{example.data.status === "success" && <Output output={example.data.output || []} />}
					</div>
				</SplitPane>
			</div>
		);
	}
}

const mapStateToProps = state => ({
	apps: userSelectors.selectApps(state),
	splitSize: labSelectors.selectSplitSize(state),
	authedUser: labSelectors.selectAuthedUser(state),
});

const mapDispatchToProps = {
	changeSplitSize: labActions.changeSplitSize,
	changeExampleData: labActions.changeExampleData,
	runJsExample: labActions.runJsExample,
};

const LabContentJsContainer = ReactRedux.connect(
	mapStateToProps,
	mapDispatchToProps
)(LabContentJs);
export default LabContentJsContainer;



// WEBPACK FOOTER //
// ./src/components/LabContentJs.tsx